<template>
    <div>
        <v-simple-table>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Nama</th>
                    <th>Periode</th>
                    <th>Harga khusus</th>
                    <th>Kadaluarsa</th>
                    <th></th>
                </tr>
            </thead>

            <tbody>
                <tr
                    v-for="(registrationLink, idx) in registrationLinks"
                    :key="registrationLink.id"
                >
                    <td>{{ idx + 1 }}</td>
                    <td>{{ registrationLink.title }}</td>
                    <td>{{ registrationLink.period.title }}</td>
                    <td>{{ registrationLink.specialPrice }}</td>
                    <td>{{ registrationLink.validUntil }}</td>
                    <td>
                        <v-btn @click="copyLink(registrationLink)" icon>
                            <v-icon>mdi-content-copy</v-icon>
                        </v-btn>
                        <v-btn @click="$emit('qrcode', registrationLink)" icon>
                            <v-icon>mdi-qrcode</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>

        <v-snackbar v-model="copiedSnackbar">
            Link disalin
        </v-snackbar>
    </div>
</template>

<script>
import moment from '@/plugins/moment'

export default {
    data: () => ({
        registrationLinks: null,
        copiedSnackbar: false,
    }),

    methods: {
        async update() {
            const response = await this.$apiv2.get('registration-link', { loader: 'appbar' })

            this.registrationLinks = response.data.registrationLinks
                .map(registrationLink => ({
                    ...registrationLink,
                    validUntil: registrationLink.validUntil
                        ? moment(registrationLink.validUntil).formatLongDayAndTime()
                        : null
                }))
        },

        copyLink(registrationLink) {
            const link = `${process.env.VUE_APP_BASE_URL}d/${registrationLink.slug}`

            navigator.clipboard.writeText(link)
            this.copiedSnackbar = true
        }
    },

    created() {
        this.update()
    }
}
</script>
